import React from 'react';
import { sanitizeCalculToString } from '../../../../helpers/number/sanitizeCalul';
import { statusChoice } from '../../../../types/commande/status.def';
import { Enum_Commande_Status } from '../../../../graphql/generated/graphql';
import { CommandeStateUpdate } from '../../../../types/commande/formatUpdateCommande';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { CommandDetailLine } from '../../../atoms/Texts/CommandDetailLine';
import { HeaderText } from '../../../atoms/Texts/HeaderText';
import emojis from '../../../../theme/emoji';
import { Select } from '../../../atoms/Inputs/Select';
import useStyle from '../FormCommande/formCommande.style';
import { PaymentMethodBlock } from 'components/molecules/Blocks/PaymentMethodBlock';

interface CommandeFieldsUpdateProps {
  handleChange: (e) => any;
  commande: CommandeStateUpdate['commande'];
}

export const CommandeFieldsUpdate = ({
  handleChange,
  commande
}: CommandeFieldsUpdateProps) => {
  const classes = useStyle();
  const customOnChange = (name, value) => {
    const e = {
      target: {
        value: value,
        name: name
      }
    };
    handleChange(e);
  };
  return (
    <div>
      <HeaderText text={'Information Commande'} emoji={emojis['Package']} />
      <FeatureContainer>
        <CommandDetailLine
          title={'Numéro de commande'}
          text={commande.numerocommande}
          withDivider={true}
        />
        <CommandDetailLine
          title={'Montant de la commande (hors frais livraison)'}
          text={sanitizeCalculToString(commande.totalttc) + '€'}
          withDivider={true}
        />
        <CommandDetailLine
          title={'Frais de livraison'}
          text={sanitizeCalculToString(commande.fraislivraison) + '€'}
          withDivider={true}
        />
        <CommandDetailLine
          title={'Contribution ONG'}
          text={commande.customerContributedToTheOng ? '1€' : '0€'}
          withDivider={true}
        />
        <CommandDetailLine
          title={'Total à payer'}
          text={commande.prixTotal + '€'}
          withDivider={true}
        />
        <CommandDetailLine
          title={'Payé ?'}
          text={commande.status === Enum_Commande_Status.Paye ? 'OUI' : 'NON'}
          withDivider={true}
        />
        <div className={classes.selectdiv}>
          <span>Statut de la commande</span>
          <Select
            productsOptions={statusChoice}
            value={commande.status}
            onChange={value => customOnChange('status', value)}
            variant="reporting"
          />
        </div>
      </FeatureContainer>
      <PaymentMethodBlock
        defaultValue={commande.methodepaiement}
        onChange={value => customOnChange('methodepaiement', value)}
      />
    </div>
  );
};
